// src/components/common/FloorPlanModal.tsx

import React, { useEffect, useState } from 'react';

/**
 * FloorPlanModalProps
 * floorPlanUrl: 間取り図画像のURL (無ければダミー画像を表示)
 * linkText: モーダルを開くトリガーテキスト(デフォルト 'Floor Plan')
 */
interface FloorPlanModalProps {
  floorPlanUrl?: string;
  linkText?: string;
}

export const FloorPlanModal: React.FC<FloorPlanModalProps> = ({
  floorPlanUrl,
  linkText = 'Floor Plan',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // 画像URLが無い場合はプレースホルダーを使用
  // TODO: ここを実際の未指定用ダミー画像に
  const imageSrc = floorPlanUrl;

  // モーダル開閉時に body のスクロールを制御
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  const handleOpenModal = () => setIsOpen(true);
  const handleCloseModal = () => setIsOpen(false);

  return (
    <>
      {/* モーダル開くトリガー */}
      <div className="underline mr-2 cursor-pointer" onClick={handleOpenModal}>
        {linkText}
      </div>

      {/* モーダル */}
      {isOpen && (
        <div
          className="
            fixed inset-0 z-50
            flex items-center justify-center
            bg-whiteYellow bg-opacity-90
          "
          onClick={handleCloseModal} // 背景クリックでモーダルを閉じる
        >
          <div
            className="
              relative
              bg-whiteYellow
              rounded
              max-h-[80%]
              overflow-auto
              cursor-default
              p-4
            "
            onClick={(e) => e.stopPropagation()} // モーダル内部クリックで閉じないように
          >
            <div
              className="
                relative
                w-7/8
                h-[300px]
                mx-auto
                p-2
                border border-black
              "
            >
              <img
                src={imageSrc}
                alt="Floor Plan"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="mt-4 text-center">
              <button onClick={handleCloseModal} className="text-xl font-bold">
                ×
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
